import { ContactBgColorSettingModalComponent } from './contact-bg-color-setting-modal.component';
import { CommonModule } from '@angular/common';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { CollapseModule } from 'ngx-bootstrap';
import { PostalCodeInputModule } from '@blcloud/bl-ng-share-module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ContactStatusBgColorSettingResource } from '@blcloud/bl-ng-resource';

@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    CollapseModule,

    PostalCodeInputModule,
  ],
  exports: [
    ContactBgColorSettingModalComponent
  ],
  declarations: [
    ContactBgColorSettingModalComponent
  ],
  entryComponents: [
    ContactBgColorSettingModalComponent
  ],
  providers: [
    ContactStatusBgColorSettingResource,
  ]
})
export class ContactBgColorSettingModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ContactBgColorSettingModalModule,
      providers: [
        CollapseModule.forRoot().providers,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/contact-bg-color-setting/contact-bg-color-setting-modal.module.ts